import type { CategorySelectOption, CategoryState } from '../../types.tsx';

export const toCategorySelectOption = (
	jiraOption: CategoryState | null,
): CategorySelectOption | null => {
	if (jiraOption == null) {
		return null;
	}
	return {
		value: String(jiraOption.optionId),
		label: jiraOption.value || '',
		color: jiraOption.color,
	};
};
